import type { JwtConfig } from './jwtDefaultConfig'
import type { AxiosInstance } from 'axios'

import defaultConfig from './jwtDefaultConfig'
import JwtService from './jwtService'

let jwt: Nullable<JwtService>

export function useJwt(axiosIns?: AxiosInstance, jwtOverrideConfig?: JwtConfig) {
    import.meta.env.DEV &&
        console.warn('[Salem Internal API] El uso de useJwt no se recomienda, y estará en desuso en el futuro')
    if (!jwt) {
        if (!axiosIns) console.error('Se configuró el servicio de JWT sin una instancia de axios')
        jwt = new JwtService(axiosIns!, jwtOverrideConfig ?? defaultConfig)
    }

    return {
        jwt,
    }
}

// eslint-disable-next-line import/no-default-export
export default useJwt
